var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.06351 5.7871L17.1019 2.44099C21.6067 0.939373 24.0542 3.39871 22.5644 7.90354L19.2183 17.9419C16.9718 24.6933 13.2828 24.6933 11.0363 17.9419L10.0431 14.9624L7.06351 13.9692C0.312165 11.7227 0.312165 8.04543 7.06351 5.7871Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.34,
    d: "M10.2676 14.4538L14.5005 10.2091",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.76618b7e96ef62efbd0e85d3d586eeda.svg";
export { ForwardRef as ReactComponent };